export const payload = {
  receiveMutation: 'RECEIVE_COMPANIES',
  receivingMutation: 'RECEIVING_COMPANIES',
  receiveMetadataMutation: 'RECEIVE_COMPANY_METADATA',
  savingMutation: 'SAVING_COMPANY',
  updatingMutation: 'UPDATING_COMPANY',
  deleteMutation: 'DELETE_COMPANY',
  deletingMutation: 'DELETING_COMPANY',
  incrementMutation: 'INCREMENT_COMPANY_COUNT',
  resetMetaMutation: 'RESET_COMPANY_META',
  clearMutation: 'CLEAR_COMPANY_STATE',
  moduleName: 'company',
  endpoint: 'companies',
  defaultModelGetter: 'getDefaultCompany',
  nested: {
    bank: {
      receiveMutation: 'RECEIVE_BANKS',
      listSchemaRequired: false,
      endpoint: 'banks'
    },
    address: {
      receiveMutation: 'RECEIVE_ADDRESSES',
      listSchemaRequired: false,
      endpoint: 'addresses'
    }
  }
}
